// Desc: Configuration file for the client
const APP_ENV = process.env.REACT_APP_ENV;
const APP_VERSION = process.env.REACT_APP_VERSION || 'v0.0.1';
const REACT_APP_HOST = process.env.REACT_APP_HOST;
const REACT_APP_NAME = process.env.REACT_APP_NAME;
const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;

const EMAIL_SERVICE_ID = process.env.REACT_APP_EMAIL_SERVICE_ID;
const EMAIL_TEMPLATE_ID = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
const EMAIL_PK = process.env.REACT_APP_EMAIL_PK;

// Conditionally set the API URL based on the environment
export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === 'false' 
						|| !process.env.REACT_APP_IS_LOCAL 
						? false : true;
export const IS_PROD = process.env.REACT_APP_ENV === 'production' ? 'https://precision-x-dev.adaptive.biz' : 'https://precision-x-dev.adaptive.biz';
export const API_URL = IS_LOCAL ? 'http://localhost:8000' : IS_PROD;
export const ON_PREM = process.env.REACT_APP_ON_PREM_OPTIONS === 'false' 
						|| !process.env.REACT_APP_ON_PREM_OPTIONS 
						? false : true;

// Configs
const email = {
    EMAIL_SERVICE_ID,
    EMAIL_TEMPLATE_ID,
    EMAIL_PK,
}

const appConfig = {
    APP_ENV,
    APP_VERSION,
    REACT_APP_NAME,
    REACT_APP_HOST,
    JWT_SECRET,
    email
}

export default appConfig;